export default "__VITE_ASSET__bk7UWcE$__"